const removeMd = require('remove-markdown');

const GLOSSARY_ITEM_TYPE = {
  VALUE: 'value',
  TITLE: 'title',
};

function fetchGlossaryListParams(params) {
  const defaultParams = {
    category: 'recpR5YrmA7YixItg', // All Categories ID from Airtable
    search: '', // Setting the search keyword as blank to get all the data from Airtable
  };
  return {...defaultParams, ...params};
}

function getSearchedDataList(DATA_LIST, params, fetchParams) {
  const searchResults = DATA_LIST.filter((listItem) => {
    let isCategoryValid = true;
    if (fetchParams.category) {
      isCategoryValid = listItem.categories.includes(fetchParams.category);
    }
    return isCategoryValid;
  });

  return searchResults;
}

function sortDataList(searchResults) {
  const sortedDataList = searchResults.sort((first, second) => {
    if (removeMd(first.title).toUpperCase() === removeMd(second.title).toUpperCase()) return 0;
    else if (removeMd(first.title).toUpperCase() > removeMd(second.title).toUpperCase()) return 1;
    else return -1;
  });
  return sortedDataList;
}

function makeGroupedGlossaryList(glossaryList) {
  let {list} = glossaryList.reduce(
    ({category, list}, listItem, index) => {
      let firstLetter = removeMd(listItem.title).substring(0, 1).toUpperCase();
      if (firstLetter === category) {
        list.push({...listItem, type: GLOSSARY_ITEM_TYPE.VALUE});
      } else {
        category = firstLetter;
        list.push({
          type: GLOSSARY_ITEM_TYPE.TITLE,
          title: firstLetter,
          id: `${index}_${firstLetter}`,
        });
        list.push({
          ...listItem,
          type: GLOSSARY_ITEM_TYPE.VALUE,
        });
      }
      return {category, list};
    },
    {category: null, list: []}
  );

  console.log(list)
  return list;
}

/**
 * Get the glossary list to display in the glossary component pass the function that is present in AirtableUtils.js if present or make another function
 * @param {Function} getDataList Function to get data from the given data source
 * @param {string} url URL for particular Data source
 * @param {string} apiKey API key to access Data source
 * @returns {Array} List of all the data from data source
 */
export function getGlossaryListWithAirtable(getDataList, url, apiKey, project) {
  return (params) => {
    return new Promise(async (resolve, reject) => {
      const fetchParams = fetchGlossaryListParams(params);
      const dataList = await getDataList(url, apiKey, params.search, project);
      const searchResults = getSearchedDataList(dataList, params, fetchParams);
      const finalData = makeGroupedGlossaryList(sortDataList(searchResults));
      resolve(finalData);
    });
  };
}

/**
 * This is to fetch individual items from Airtable by passing the fetch function, url, apiKey and the ID for the item that needs to be fetched
 * @param {Function} fetchData Function to fetch data
 * @param {string} url URL from which the Data needs to be fetched
 * @param {string} apiKey API Key to access the particular Data source
 * @returns {Array} List of data that is fetched
 */
export function getIndividualGlossaryItem(fetchData, url, apiKey) {
  return (glossaryId) => {
    return new Promise(async (resolve, reject) => {
      let dataItem = await fetchData(url, apiKey, glossaryId);
      resolve(dataItem);
    });
  };
}
